// TODO: we need to get rid of this hook and make the framework support filtering natively
import { useCallback } from 'react'

import { CompensationsFilters } from 'modules/compensations/types/filters'
import { SyncParameters, useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const useSync = () => {
  const { setSyncFilterParameters, runSynchronisation, syncParameters, configuration, ...context } =
    useIntegrationsSyncContext()

  const convertFiltersToParameters = useCallback(
    (filters?: CompensationsFilters): SyncParameters => {
      const parameters: SyncParameters = []

      if (filters?.legalEntityIds?.length) {
        parameters.push({ key: 'legal_entity_ids', value: filters.legalEntityIds.join(',') })
      }
      if (filters?.teamIds?.length) {
        parameters.push({ key: 'team_ids', value: filters.teamIds.join(',') })
      }
      if (filters?.workplaceIds?.length) {
        parameters.push({ key: 'workplace_ids', value: filters.workplaceIds.join(',') })
      }
      if (filters?.validationTypes?.length) {
        parameters.push({ key: 'validation_types', value: filters.validationTypes.join(',') })
      }
      if (filters?.integrationsAgreggatedSyncableStates?.length) {
        parameters.push({
          key: 'integrations_agreggated_syncable_states',
          value: filters.integrationsAgreggatedSyncableStates.join(','),
        })
      }

      return parameters
    },
    []
  )

  const setFilters = useCallback(
    // TODO: add generic filters instead of custom for each type
    (filters?: CompensationsFilters) => {
      if (configuration.capabilityType !== 'compensations') {
        return []
      }

      const parameters = convertFiltersToParameters(filters)
      setSyncFilterParameters(parameters)
    },
    [convertFiltersToParameters, setSyncFilterParameters, configuration.capabilityType]
  )

  const runSync = useCallback(async () => {
    await runSynchronisation()
  }, [runSynchronisation])

  return {
    ...context,
    runSync,
    setFilters,
    syncParameters,
  }
}
